import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import '../styles/pages/terms_privacy.scss'

const Terms = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          terms {
            name
          }
        }
      }
    }
  `)

  const { name } = data.site.siteMetadata.terms

  return (
    <>
      <h1 className="legal-heading">{name}</h1>
      <div className="container">
        <div className="terms">
          <h3 className="terms__heading">Activity Information</h3>
          <p>
            Thank you for visiting <strong>kcosa.com</strong>. Please read these
            terms and conditions carefully before using our site. Please do not
            use this website, if you do not agree with our terms and conditions.
            They outline the rules and regulations for the use of{' '}
            <strong>kcosa.com</strong>, and you will be bound by them from the
            moment you've enter the site.
          </p>

          <h4 className="terms__subheading">Cookies</h4>
          <p>
            Cookies are text files that contain data from visited websites
            stored on the user's computer by a browser. A cookie is primarily
            used to store information about a user's visit to the site. The term
            cookies also includes other technologies that fulfill the same
            functions as cookies. As with most websites on the planet, we may or
            may not use cookies from time to time, at any given time. Therefore,
            by accessing <strong>kcosa.com</strong>, you agree to the use of
            cookies in accordance with local laws and regulations. Furthermore,
            some of our affiliate/advertising partners may also use cookies.
          </p>

          <h4 className="terms__subheading">Disclaimer</h4>
          <p>
            <strong>This is a personal blog. </strong> Any views or opinions
            represented in this blog are personal and belong solely to the
            author and do not represent those of people, institutions or
            organizations, that the blog owner may or may not be associated with
            in a professional capacity, unless explicitly stated. Any views or
            opinions expressed in this blog are not intended to malign any
            religion, ethnic group, club, organization, company, or individual .
          </p>
          <p>
            <strong>
              All content provided on this blog is for informative purposes
              only.
            </strong>{' '}
            The owner of this blog makes no representations as to the accuracy
            or completeness of any information on this site or found by
            following any link on this site. The owner will not be liable for
            any errors or omissions in this information nor for the availability
            of this information. The owner will not be liable for any losses,
            injuries, or damages from the display or use of this information.
          </p>
          <p>This policy is subject to change at any time.</p>
        </div>
      </div>
    </>
  )
}

export default Terms
